import axios from "axios";

export default {
    getTodayArticle() {
        return axios.get("/cc/Article/getTodayArticle");
    },
    getAuthorList() {
        return axios.get("/cc/Article/getAuthorList");
    },
    getList(obj) {
        return axios.post("/cc/Article/getList", obj);
    },
    like(obj) {
        return axios.post("/cc/Article/like", obj);
    },
    collect(obj) {
        return axios.post("/cc/Article/collect", obj);
    },
    addwxShare(obj) {
        return axios.get(
            "http://daoda1997.daoda1997.cn/Open/Jssdk/getShjwJssdk?url=" +
            encodeURIComponent(obj.url)
        );
    },
    /**
     * 
     * @param {Object} obj 
     * @param {String} obj.id
     */
    getArticleById(obj) {
        return axios.post("/cc/Article/getArticleById", obj);
    },
    /**
     * 
     * @param {Object} obj 
     * @param {Number} obj.page 
     * @param {Number} obj.row 
     */
    getMyCollects(obj) {
        return axios.post("/cc/Student/getMyCollects", obj);
    }
}